import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import styled from 'styled-components';

import BubbleContent from '../content/bubble_content';
import ConversationItem from 'models/conversation_item';
import ConversationMessageAttachments from 'components/customer/conversation_history/conversation_items_v2/message/attachments/conversation_message_attachments';
import ItemContext from '../item_context';
import RedactedItem from 'components/customer/conversation_history/conversation_items_v2/redacted_item';
import SafeHtml from 'components/common/safe_html';
import { useShouldTranslate } from 'components/hooks/use_conditional_translation';

export default function ChatHTMLContent({ className, item, status, withoutAttachments, withoutBubble }) {
  const { isViewTranslation } = useContext(ItemContext);
  const shouldTranslate = useShouldTranslate(item, !isViewTranslation);
  const body = renderBody();
  const attachments = withoutAttachments ? null : renderAttachments();

  return withoutBubble ? (
    <>
      {body}
      {attachments}
    </>
  ) : (
    <BubbleContent
      className={classnames('chatItem-content html', className)}
      data-aid={`chatItem-content-${item.id}`}
      item={item}
      status={status}
    >
      {body}
      {attachments}
    </BubbleContent>
  );

  function renderBody() {
    if (item.content.isRedacted) {
      return <RedactedItem />;
    }
    const text = shouldTranslate ? item.translation.content : _.get(item, 'content.text');
    const html = text.replace(/(?<=>)\s*\n\s*(?=<)/g, '');
    return <ChatSafeHTML className="chatItem-content-rich" html={html} setDirection />;
  }

  function renderAttachments() {
    let itemAttachments = item.content.attachments;
    if (!itemAttachments || itemAttachments.length === 0) {
      return null;
    }
    return <ConversationMessageAttachments attachments={itemAttachments} />;
  }
}

export const ChatSafeHTML = styled(SafeHtml)`
  box-shadow: none;
  outline: none;
  *:first-child {
    margin-top: 0;
  }
  *:last-child {
    margin-bottom: 0;
  }
  pre {
    white-space: pre-wrap;
  }
  img {
    max-width: 100%;
    height: auto;
  }
  ol {
    margin-top: 0;
    margin-left: 15px;
    padding-left: 0;

    li {
      list-style-position: outside;
      padding-left: 0;
      padding-top: 10px;

      p {
        margin: 0;
      }
    }
  }
  ul {
    margin-top: 0;
    margin-left: 15px;
    padding-left: 0;

    li {
      list-style-position: outside;
      padding-left: 0;
      padding-top: 0;

      p {
        margin: 0;
      }
    }
  }
`;

ChatHTMLContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  status: PropTypes.string,
  withoutAttachments: PropTypes.bool,
  withoutBubble: PropTypes.bool,
};
